import React, {useEffect, useRef, useState} from 'react';
import {UseLoader} from "../../../hooks/useLoader";
import {useForm} from "react-hook-form";
import {Toast} from "primereact/toast";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {confirmDialog} from "primereact/confirmdialog";

import { guardarDeduccionSinLiq, selectMaestros} from "../../../api/liquidacionDeduccion.service";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {arrayNum, sumaIngreso} from "../../../shared/utils/utils";
import {anios, meses} from "../../../shared/types/constantes";

export const FormDeducciones = ({fields, asociado_id, reload, generarSyP}) => {

    const [handleLoader] = UseLoader();
    const toast = useRef(null);
    const [fondos, setFondos] = useState([]);
    const [terceros, setTerceros] = useState([]);
    const {register, handleSubmit,resetField , formState: {errors}} = useForm();



    useEffect(() => {
        selectMaestros().then(r => {
            if (r.estado === 200) {
                const data = r.data;
                setFondos(data.fondo);
                setTerceros(data.tercero);
            } else {
                toast.current?.show({severity: 'warn', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;
            }
        });
        return () => {
            setFondos([])
            setTerceros([])
        };
    }, []);

    const ingreso = fields.length > 0 ? sumaIngreso(fields) : 0;

    const onSubmit = payload => {
        try {

            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoader(true);
                    const datos = {...payload,  ingreso: ingreso, asociado_id}

                   const response = await guardarDeduccionSinLiq(datos)
                    handleLoader(false);

                    if (response.estado != 200) {
                        toast.current?.show({
                            severity: 'error',
                            summary: 'Alerta',
                            detail: response.mensaje,
                            life: 3000
                        });
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                    resetField("fondo");
                    resetField("tercero");
                    resetField("concepto");
                    resetField("valor");
                    resetField("cuota");
                    resetField("egreso");
                    reload()
                }
            });

        } catch (e) {
            handleLoader(false)
            console.log(e)
        }
    }


    const periodo = arrayNum(20);

    const genSaludYpension = (e) => {
        e.preventDefault()

        generarSyP();
    }

    return (
        <>
            <Toast ref={toast}/>
            <ContainerForm>
                <form onSubmit={handleSubmit(onSubmit)} autoComplete="false">
                    <h6 className="title-modal">
                        Crear deducciones
                    </h6>
                    <div className="row">
                        <ContainerGroupForm width="lg:w-6/12">
                            <label
                                className="label-form"
                                htmlFor="anio"
                            >
                                Año *
                            </label>
                            <select name="anio"
                                    className="form-input-small"
                                    {...register("anio", {required: true})}
                                    id="anio">
                                <option value="">...</option>
                                {anios.map((p, i) => <option key={i} value={p}>{p}</option>)}
                            </select>
                            {errors.anio?.type === 'required' &&
                                <span className="text-red-600 font-bold text-xs">Campo requerido</span>}
                        </ContainerGroupForm>
                        <ContainerGroupForm width="lg:w-6/12">
                            <label
                                className="label-form"
                                htmlFor="mes"
                            >
                                Mes *
                            </label>
                            <select  name="mes"
                                    className="form-input-small"
                                     {...register("mes", {required: true})}
                                    id="mes">
                                <option value="">...</option>
                                {meses.map((p, i) => <option key={i} value={p.value}>{p.name}</option>)}
                            </select>

                            {errors.anio?.type === 'required' &&
                                <span className="text-red-600 font-bold text-xs">Campo requerido</span>}
                        </ContainerGroupForm>
                    </div>
                    <div className="row">
                        <ContainerGroupForm width="w-full">
                            <label
                                className="label-form"
                                htmlFor="fondo"
                            >
                                Fondo *
                            </label>

                            <select
                                className="form-input-small"
                                {...register("fondo", {required: true})}
                                id="tipoDoc">
                                <option value="">seleccione</option>
                                {fondos.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                            </select>

                            {errors.fondo?.type === 'required' &&
                            <span className="text-red-600 font-bold text-xs">Campo requerido</span>}
                        </ContainerGroupForm>
                    </div>
                    <div className="row">
                        <ContainerGroupForm width="w-full">
                            <label
                                className="label-form"
                                htmlFor="fondo"
                            >
                                Tercero *
                            </label>

                            <select
                                className="form-input-small"
                                {...register("tercero", {required: true})}
                                id="tipoDoc">
                                <option value="">seleccione</option>
                                {terceros.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                            </select>

                            {errors.tercero?.type === 'required' &&
                            <span className="text-red-600 font-bold text-xs">Campo requerido</span>}
                        </ContainerGroupForm>
                    </div>
                    <div className="row">
                        <ContainerGroupForm width="w-full">
                            <label
                                className="label-form"
                                htmlFor="concepto"
                            >
                                Concepto *
                            </label>
                            <textarea
                                rows={2}
                                {...register("concepto", { maxLength: 200})}
                                className="form-input-small"
                                id="concepto">
                            </textarea>

                            {errors.concepto?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 200 caracteres</span>}
                            {errors.concepto?.type === 'required' &&
                            <span className="text-red-600 font-bold text-xs">El campo es requerido</span>}

                        </ContainerGroupForm>
                    </div>
                    <div className="row">
                        <ContainerGroupForm width="w-full">
                            <label
                                className="label-form"
                                htmlFor="valor"
                            >
                                Valor *
                            </label>
                            <input
                                type="number"

                                {...register("valor", {maxLength: 11, required: true})}
                                className="form-input-small"
                                id="valor"/>

                            {errors.valor?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 30 caracteres</span>}
                            {errors.valor?.type === 'required' &&
                            <span className="text-red-600 font-bold text-xs">El campo es requerido</span>}
                        </ContainerGroupForm>
                    </div>
                    <div className="row">

                        <ContainerGroupForm width="lg:w-6/12">
                            <label
                                className="label-form"
                                htmlFor="cuotas"
                            >
                                Cuotas *
                            </label>
                            <select name="Cuotas"
                                    className="form-input-small"
                                    {...register("cuota", {maxLength: 6, required: true})}
                                    id="periodo">
                                <option value="">Seleccione...</option>
                                {periodo.map((p, i) => <option key={i} value={p}>{p}</option>)}
                            </select>

                            {errors.cuota?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 6 caracteres</span>}
                            {errors.cuota?.type === 'required' &&
                            <span className="text-red-600 font-bold text-xs">El campo es requerido</span>}
                        </ContainerGroupForm>
                        <ContainerGroupForm width="lg:w-6/12">
                            <label
                                className="label-form"
                                htmlFor="egreso"
                            >
                                Egreso *
                            </label>
                            <input
                                type="text"

                                {...register("egreso", {maxLength: 30})}
                                className="form-input-small"
                                id="egreso"/>

                            {errors.egreso?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 30 caracteres</span>}
                            {errors.egreso?.type === 'required' &&
                            <span className="text-red-600 font-bold text-xs">El campo es requerido</span>}
                        </ContainerGroupForm>
                    </div>
                    <div className="row mt-4">
                        <ContainerGroupForm width="lg:w-12/12">
                            <button
                                className="primary-color-btn btn w-full"
                                type="submit"
                            >
                                Guardar
                            </button>

                        </ContainerGroupForm>

                    </div>
                    <div className="row mt-4">
                        <ContainerGroupForm width="lg:w-12/12">
                            <button
                                className="secundary-color-btn btn w-full"
                                onClick={genSaludYpension}
                            >
                                Generar salud y pension
                            </button>

                        </ContainerGroupForm>

                    </div>
                </form>
            </ContainerForm>
        </>
    );
};

FormDeducciones.defaultProps = {
    fields: []
}
